export default {
  "HitPaw Online Audio Joiner": "HitPaw Joigneur d'audio en ligne",
  "Merge Audio": "Fusionner l'audio",
  "Merge multiple audio tracks into one.": "Fusionner plusieurs pistes audio en une.",
  "Merge New": "Fusionner un nouveau",
  "Merge failed": "La fusion a échouée",
  "Fade in": "Faire effondrer le son",
  "Fade out": "Faire disparaître le son",
  "Add tracks": "Ajouter des pistes",
  "Format": "Format",
};
